export const styles = theme => ({
  filterPanelContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '80vh',
    width: '100%',
    marginLeft: 10,
    padding: '8px 10px 0 10px',
    display: 'flex',
    flexDirection: 'column',
  },
  serviceGroupContainer: {
    width: '100%',
    paddingBottom: theme.spacing(1.5),
    paddingRight: theme.spacing(1),
  },
  noFiltersContainer: {
    paddingTop: theme.spacing(5),
    textAlign: 'center',
  },
  faCheckbox: {
    marginLeft: 0,
  },
  applyFilterButton: {
    width: '75%',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '4px 16px',
    fontWeight: 'bold',
    fontSize: '0.8rem',
    background: '#547096',
    color: '#fff',
    border: 'none',
    borderRadius: 150,
    cursor: 'pointer',
    transition: 'background 0.2s',
    marginBottom: 0,
    marginTop: 16,
    height: 28,
  },
});
